var $ = require('jquery');
var manualRuutuEmbed = require('./manualruutuembed');

$(function () {
    // Embed automatically on initial load
    manualRuutuEmbed();
});



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/ruutuembed.js
// module id = 11
// module chunks = 0